export function getArrayTotal(arr: number[]): number {
  return arr.reduce((sum, n) => sum + n, 0);
}
